// extracted by mini-css-extract-plugin
export default {"root":"TransactionListItem_root__1-ywv"};